import { Checkbox } from '@vwfs-bronson/bronson-react';
import i18n from 'i18next';
import React, { FunctionComponent } from 'react';
import { useFormikContext } from 'formik';
import { FormField } from '..';

interface CheckboxFormFieldProps {
  labelTranslationKey: string;
  fieldName: string;
  isDisabled?: boolean;
  testId?: string;
  onCheckedChange?: (checked: boolean, setFieldValue: any) => void;
}

export const CheckboxFormField: FunctionComponent<CheckboxFormFieldProps> = ({
  labelTranslationKey,
  isDisabled,
  fieldName,
  testId,
  onCheckedChange,
}): React.JSX.Element => {
  const { setFieldValue } = useFormikContext<any>();
  return (
    <FormField
      type="checkbox"
      name={fieldName}
      testId={testId}
      labelText=""
      render={(fieldProps) => (
        <Checkbox
          {...fieldProps}
          name={fieldName}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          checked={fieldProps.value}
          onChange={(e) => {
            const { checked } = e.target;
            setFieldValue(fieldName, checked);
            onCheckedChange?.(checked, setFieldValue);
          }}
        >
          {i18n.t(labelTranslationKey)}
        </Checkbox>
      )}
    />
  );
};
